import { useMutation } from '@tanstack/react-query';
import { adminManualReferralsApi } from '../services/adminManualReferralsApi';
import type {
  BulkReferralResponseDto,
  BulkReferralUploadPayload,
} from '../types/bulk-referral.type';

export const useBulkReferralDryRun = () => {
  return useMutation<BulkReferralResponseDto, Error, BulkReferralUploadPayload>({
    mutationFn: (payload: BulkReferralUploadPayload) =>
      adminManualReferralsApi.uploadBulkReferrals(payload),
  });
};
